import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaAtividadesCriticas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const VistoriaAtividadesCriticas = (Id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/getvistoria/${Id}`, data, config)
const getvistoriaItensPdfMob = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/getvistoriaItensPdfMob`, data, config)

const surveycriticalactivityRepository = {
  VistoriaAtividadesCriticas,
  getvistoriaItensPdfMob
}
export default surveycriticalactivityRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/surveycriticalactivity.js